import React from 'react'
import PropTypes from 'prop-types'

import errorImage from '../../../../assets/cashOutError.png'
import styles from './styles.module.scss'

const ValidationsError = ({ isPurchase }) => (
  <div className={styles.container}>
    <img className="mb-32" src={errorImage} alt="validations-error" />
    <p className="mb-8 medium bold">
      {isPurchase
        ? 'Down payment should be lower than purchase price.'
        : 'Your loan amount cannot be greater than your home’s value'}
    </p>
    <p className="bodySmall neutral500">
      {isPurchase
        ? 'Please update your down payment and purchase price to see rates.'
        : 'Please update the loan amount and home value to see loan offers.'}
    </p>
  </div>
)
ValidationsError.propTypes = {
  isPurchase: PropTypes.bool.isRequired,
}
export default ValidationsError
